/**
 * Place any jQuery/helper plugins in here.
 */
(function (cash) {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = cash('.permission-tree input[type="checkbox"]');

    permissionTree.on('click change', function (){
        if(cash(this).is(':checked')) {
            cash(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            cash(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if(cash(this).is(':checked')) {
            cash(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    cash('form').on('submit',function () {
        disableSubmitButtons(cash(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    cash('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();
        let popup_title = 'Are you sure you want to delete this item?';
        if( cash(this).data('popupTitle') != '' ){
            popup_title = cash(this).data('popupTitle');
        }
        cash('.dropdown').dropdown('hide');
        Swal.fire({
            title: popup_title,
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                if ( cash(this).data('component') != '' ){
                    let component = cash(this).attr("data-component");
                    let component_index = cash(this).attr("data-component-index");

                    let fd = new FormData(cash(this)[0]);
                    window.axios.delete(cash(this).attr('action'),fd)
                    .then(function(response){
                        Livewire.components.getComponentsByName(component)[component_index].$wire.$refresh();
                        showNotification('success',response.data.title,response.data.content);
                    }).catch(function (error) {
                        showNotification('failure',error.response.data.title,error.response.data.content);
                    })
                }else{
                    this.submit()
                }

            } else {
                enableSubmitButtons(cash(this));
            }
        });
    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Are you sure you want to do this?',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Cancel',
                icon: 'warning'
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons(cash(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to do this?',
            showCancelButton: true,
            confirmButtonText: 'Continue',
            cancelButtonText: 'Cancel',
            icon: 'info',
        }).then((result) => {
            result.value && window.location.assign(cash(this).attr('href'));
        });
    });

    // Remember tab on page load
    cash('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = cash(e.target).attr('href');
        console.log('Changing hash tabs');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        // cash('.nav-link[href="'+hash+'"]').tab('show');
    }
    // Enable tooltips everywhere
    // cash('[data-toggle="tooltip"]').tooltip();
})(cash);

window.editable_input = function(default_data) {
    return {
        text: default_data,
        origText: default_data,
        isEditing: false,
        previousText: this.text,
        toggleEditingState($wire) {
            this.isEditing = !this.isEditing;
            if (this.isEditing) {
                this.$nextTick(() => {
                    this.$refs.input.focus();
                    this.previousText = this.text;
                });
            }else{
                this.updateWire($wire)
            }
        },
        disableEditing($wire) {
            this.isEditing = false;
            this.updateWire($wire);
        },
        undoEdit($wire){
            this.text = this.previousText;
            this.isEditing = false;
            this.updateWire($wire);
            // return;
        },
        resetEdit($wire){
            this.text = this.origText;
            this.isEditing = false;
            this.updateWire($wire);
        },
        updateWire: _.debounce(function($wire) {
            if( this.text != this.previousText){
                $wire.set('value',this.text);
            }
        }, 300, {'leading':true})
    };
};
